interface Props {
  variant: '1' | '2' | '3'
  className?: string
}

export default function BannerEllipse({ variant, className }: Props) {
  if (variant === '1') {
    return (
      <svg
        width='322'
        height='279'
        viewBox='0 0 322 279'
        fill='none'
        className={className}
        xmlns='http://www.w3.org/2000/svg'
      >
        <ellipse
          cx='276.896'
          cy='31.0226'
          rx='291.5'
          ry='230'
          transform='rotate(30.8907 276.896 31.0226)'
          fill='white'
          fillOpacity='0.15'
        />
      </svg>
    )
  } else if (variant === '2') {
    return (
      <svg
        width='372'
        height='182'
        viewBox='0 0 372 182'
        fill='none'
        className={className}
        xmlns='http://www.w3.org/2000/svg'
      >
        <ellipse
          cx='37'
          cy='329'
          rx='317'
          ry='345'
          transform='rotate(-51.726 37 329)'
          fill='white'
          fillOpacity='0.15'
        />
      </svg>
    )
  } else {
    return (
      <svg
        width='318'
        height='252'
        viewBox='0 0 318 252'
        fill='none'
        className={className}
        xmlns='http://www.w3.org/2000/svg'
      >
        <ellipse
          cx='262.947'
          cy='272.25'
          rx='180.5'
          ry='331.5'
          transform='rotate(43.0704 262.947 272.25)'
          fill='black'
          fillOpacity='0.05'
        />
      </svg>
    )
  }
}
